import React from 'react';
import { StyledPaperContainer, StyledSectionTitle } from '../../PlusWebsiteEditor.styles';
import { Favicon, WebsiteConfiguration } from '../../types/websiteConfiguration';
import { StyledContainer, StyledIconUploader } from './IconSection.styled';
import { DeepFieldErrorGetter, SetObjectFieldValue } from '../../types/handlers';

type Props = Pick<WebsiteConfiguration, 'favicon'> & { onChange: SetObjectFieldValue<Favicon>; getError: DeepFieldErrorGetter };

const FaviconSection = ({ favicon, onChange, getError }: Props) => (
  <StyledPaperContainer>
    <StyledSectionTitle>Favicon</StyledSectionTitle>
    <StyledContainer>
      <StyledIconUploader accept="image/png" helperText={getError('16x16')} title="16x16" url={favicon?.['16x16'] || ''} onChange={(base64: string) => onChange('16x16', base64, true)} />
      <StyledIconUploader accept="image/png" helperText={getError('32x32')} title="32x32" url={favicon?.['32x32'] || ''} onChange={(base64: string) => onChange('32x32', base64, true)} />
      <StyledIconUploader accept="image/png, .ico" helperText={getError('48x48')} title="48x48" url={favicon?.['48x48'] || ''} onChange={(base64: string) => onChange('48x48', base64, true)} />
      <StyledIconUploader accept="image/png" helperText={getError('192x192')} title="192x192" url={favicon?.['192x192'] || ''} onChange={(base64: string) => onChange('192x192', base64, true)} />
    </StyledContainer>
  </StyledPaperContainer>
);

export default FaviconSection;
